import { useApplicationModals } from "app/common/hooks";
import { useCollector } from "app/integration/common/hooks";
import MainLayout from "app/layouts/main";
import AppModals from 'app/modals';
import Table from "app/components/atoms/table";
import { SearchInput } from "app/components/atoms/input";
import { IconButton } from "app/components/atoms/button";
import { PrinterIcon } from "@heroicons/react/24/solid";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

const breadcrumbItems = [
  { label: "Settings", href: "#" },
  { label: "Kategori Menu", href: "#" },
];

function VariantPage() {
  const { openModal, setPayloads } = useApplicationModals();

  const [variants, setVariants, loader, collect] = useCollector({
    modelName: "variant",
  });

  return (
    <MainLayout
      activeSidebarNavigation="settings"
      activeSidebarChild="variant"
      breadcrumbItems={breadcrumbItems}
      pageTitle="Kategori Menu"
      headingButtons={[
        {
          label: "Tambah Kategori Menu",
          type: "button",
          onClick: () => openModal("variant.create"),
        },
      ]}
    >
      <AppModals
        items={["variant.create", "variant.update", "variant.delete"]}
        onSuccess={{
          "variant.create": () => collect(),
          "variant.update": () => collect(),
          "variant.delete": () => collect(),
        }}
      />
      <Table.Container>
        <Table.UtilitiesWrapper>
          <Table.SearchBarWrapper>
            <Table.SearchBarItemWrapper>
              {/* <SearchInput placeholder="Search" /> */}
            </Table.SearchBarItemWrapper>
          </Table.SearchBarWrapper>
          {/* <Table.UtilitiesButtonWrapper>
            <IconButton icon={PrinterIcon} />
          </Table.UtilitiesButtonWrapper> */}
        </Table.UtilitiesWrapper>
        <Table.Wrapper asIndex={false}>
          <Table.Header>
            <Table.HeaderRow>
              <Table.Heading>Kategori Menu</Table.Heading>
              <Table.Heading>Deskripsi</Table.Heading>
              <Table.Heading></Table.Heading>
            </Table.HeaderRow>
          </Table.Header>
          <Table.Body>
            {variants?.map((variant, key) => (
              <Table.BodyRow key={key}>
                <Table.Cell>{variant.name}</Table.Cell>
                <Table.Cell>{variant.desc}</Table.Cell>
                <Table.Cell>
                  <div className="flex">
                    <IconButton
                      icon={PencilSquareIcon}
                      onClick={(e) => {
                        setPayloads("variant.update", { id: variant.id });
                        openModal("variant.update");
                      }}
                    />
                    <IconButton
                      icon={TrashIcon}
                      onClick={(e) => {
                        setPayloads("variant.delete", { id: variant.id });
                        openModal("variant.delete");
                      }}
                    />
                  </div>
                </Table.Cell>
              </Table.BodyRow>
            ))}
          </Table.Body>
        </Table.Wrapper>
      </Table.Container>
    </MainLayout>
  );
}

export default VariantPage;
